import { api } from "@/shared/api/client";
import {
    StorageRoleGetDTO,
    StorageRoleCreateDTO,
    StorageRoleUpdateDTO,
    StorageRoleQueryFilter,
    PageStorageRoleGetDTO,
} from "@/shared/types/inventory/storageStaff";

export const storageRoleService = {
    getAll: async (params: {
        page: number;
        size: number;
        sort?: string[];
        filter?: StorageRoleQueryFilter;
    }): Promise<PageStorageRoleGetDTO> => {
        const response = await api.get<PageStorageRoleGetDTO>("/storage-roles", {
            params: {
                page: params.page - 1,
                size: params.size,
                sort: params.sort,
                code: params.filter?.code,
                name: params.filter?.name,
            },
        });
        return response.data;
    },

    getByCode: async (code: string): Promise<StorageRoleGetDTO> => {
        const response = await api.get<StorageRoleGetDTO>(`/storage-roles/${code}`);
        return response.data;
    },

    create: async (data: StorageRoleCreateDTO): Promise<StorageRoleGetDTO> => {
        const response = await api.post<StorageRoleGetDTO>("/storage-roles", data);
        return response.data;
    },

    update: async (code: string, data: StorageRoleUpdateDTO): Promise<StorageRoleGetDTO> => {
        const response = await api.put<StorageRoleGetDTO>(`/storage-roles/${code}`, data);
        return response.data;
    },

    delete: async (code: string): Promise<void> => {
        await api.delete(`/storage-roles/${code}`);
    },
};
